import { AlertType } from './../../model/shared/alert';
import { Alert } from 'app/model/shared/alert';
import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';

import * as $ from 'jquery';
import { Subject } from 'rxjs/Rx';
import { BaseResponse } from '../../response/internal/baseresponse';

@Component({
  selector: 'app-admin-popup-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, AfterViewChecked {

  @Input('show') show: boolean;
  @Input('data') data: Alert;

  showChanged: Subject<boolean> = new Subject<boolean>();

  AlertType = AlertType;

  constructor(
  ) {
    this.showChanged.subscribe((isShow) => {
      this.show = isShow;
    });
  }

  ngOnInit() {
  }

  dismissPopup() {
    this.show = false;
    this.ngOnInit();
  }

  ngAfterViewChecked() {
    if (this.show) {
      $('#admin-container #popup-alert button').filter(function() {
        return $(this).text() === 'OK';
      }).focus();
      if (this.data.literalMessage) {
        document.querySelector('#literalMessage').innerHTML = this.data.literalMessage;
        this.data.literalMessage = undefined;
      }
    }
  }

  cbContainer: any;
  confirm(cbObj) {
    cbObj.getContainer().subscribe(container => {
      this.cbContainer = container;
    });
  }

  OKPopup() {
    if (this.cbContainer) {
      this.cbContainer.yesFn();
    }
    this.dismissPopup();
  }

  confirmOnPopup(result: boolean) {
    if (result) {
      this.cbContainer.yesFn();
    } else {
      this.cbContainer.noFn();
    }
    this.dismissPopup();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/alert/alert.component.ts